// importing components
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer'
import ImageContent from '../../components/Helper/ImageContent'

// importing constants
import work from "../../constants/work.js";

// importing assets
import work1 from "../../assets/images/Work/work1.png"
import work2 from "../../assets/images/Work/work2.png"
import work3 from "../../assets/images/Work/work3.png"
import work4 from "../../assets/images/Work/work4.png"
import work5 from "../../assets/images/Work/work5.png"

// Styles
const styles = {
    servicesWraper: `flex flex-col justify-between`,
    h1Heading: 'text-[#333333] text-3xl md:text-4xl tracking-wide font-semibold text-center mb-24 lg:mb-16'
}

const index = () => {
  return (
    <>
    <div className={styles.servicesWraper}>
      <Header />

      {/* Main content */}
      <section className="flex flex-col mt-20 mb-24 px-10 lg:pl-24 lg:pr-28">
        <h1 className={styles.h1Heading}>OUR WORK</h1>
        <ImageContent  mainSection={work1} BLEND_HEADING_1={work.WORK_HEADING_1} PARAGRPH_1={work.WORK_TEXT_1} link="/projects/1" order_1={1} />
        <ImageContent  mainSection={work2} BLEND_HEADING_1={work.WORK_HEADING_2} PARAGRPH_1={work.WORK_TEXT_2} link="/projects/2" order_1={2} />
        <ImageContent  mainSection={work3} BLEND_HEADING_1={work.WORK_HEADING_3} PARAGRPH_1={work.WORK_TEXT_3} link="/projects/3" order_1={1} />
        <ImageContent  mainSection={work4} BLEND_HEADING_1={work.WORK_HEADING_4} PARAGRPH_1={work.WORK_TEXT_4} link="/projects/4" order_1={2} />
        <ImageContent  mainSection={work5} BLEND_HEADING_1={work.WORK_HEADING_5} PARAGRPH_1={work.WORK_TEXT_5} link="/projects/5" order_1={1} />
      </section>
      <footer>
        <Footer />
      </footer>
    </div>
  </>
  )
}

export default index